import { FC, useEffect, useState } from 'react';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import SurveyDefaultStep from '@/components/SurveyDefaultStep';
import MagnifyingGlassImage from '@/assets/images/magnifying-glass.png';
import analytics from '@/utils/analytics/analyticsInstance';

const PersonalizingPage: FC = () => {
  const { next } = useSurveyNavigate();
  const [dots, setDots] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev < 3 ? prev + 1 : 0));
    }, 400);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(next, 4000);

    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'Let’s personalize your shopping feed',
    });

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: 'Personalizing your feed' }}
      subTitle={{ value: 'This won’t take long' + '.'.repeat(dots) }}
      image={MagnifyingGlassImage}
    />
  );
};

export default PersonalizingPage;
